<template>
  <v-container fluid class="pa-0 mx-0">
    <v-tabs v-model="tab">
      <v-tab>Active</v-tab>
      <v-tab>Inactive</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" touchless>
      <v-tab-item>
        <stock-list
          :stocks="activeStocks"
          @update="updateStock"
          @delete="deleteStock"
        ></stock-list
      ></v-tab-item>
      <v-tab-item>
        <stock-list :stocks="inactiveStocks"></stock-list
      ></v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>
import generalMixin from "@/js/general-mixin";
import StockList from "@/components/StockList.vue";
export default {
  name: "StockList",
  mixins: [generalMixin],
  components: {
    "stock-list": StockList,
  },
  mounted: function () {
    this.$store.dispatch("getStocks");
  },
  data() {
    return {
      inStockDialog: false,
      selectedProduct: null,
      selectedStock: null,
    };
  },
  computed: {
    tab: {
      get() {
        return this.$store.getters["interactStore/stockTab"];
      },
      set(val) {
        this.$store.commit("interactStore/setStockTab", val);
      },
    },
    stocks() {
      return this.$store.getters["stocks"];
    },
    customers() {
      return this.$store.getters["customers"];
    },
    activeStocks() {
      return this.stocks.filter((e) => e.isActive);
    },
    inactiveStocks() {
      return this.stocks.filter((e) => !e.isActive);
    },
  },
  methods: {
    updateStock(selectedStock) {
      let idx = this.stocks.findIndex((e) => e.id == selectedStock.id);
      if (idx >= 0) {
        this.$set(this.stocks, idx, selectedStock);
      }
    },
    deleteStock(selectedStock) {
      let stock = this.stocks.find((e) => e.id == selectedStock.id);
      this.$set(stock, "isActive", false);
    },
  },
};
</script>
<style>
.payment-paid {
  background-color: lightgreen;
}
.image-preview {
  object-fit: contain;
  image-rendering: smooth;
  width: 40px;
  height: 40px;
}
</style>
